var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 138,
    viewBox: "0 0 137 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.2964 0.871704C30.7239 0.871704 0.154297 31.4387 0.154297 69.0138C0.154297 106.589 30.7239 137.156 68.2964 137.156C105.869 137.156 136.438 106.589 136.438 69.0138C136.438 31.4387 105.869 0.871704 68.2964 0.871704ZM106.286 46.2884L64.352 93.4637C63.3194 94.6247 61.8805 95.2223 60.4312 95.2223C59.2807 95.2223 58.1249 94.8449 57.1578 94.0743L30.9493 73.1076C28.6901 71.3018 28.3232 68.0021 30.1316 65.7403C31.9373 63.4786 35.2396 63.1116 37.4988 64.92L59.8206 82.7759L98.4493 39.3196C100.368 37.1547 103.686 36.9608 105.848 38.8845C108.013 40.8108 108.209 44.1236 106.286 46.2884Z",
    fill: "#37CB95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.4b199879.svg";
export { ForwardRef as ReactComponent };